<script>
  import List, { Item, Text, Graphic, Separator, Subheader } from '@smui/list';
  import { Icon } from '@smui/common';
  import InternalBadge from './InternalBadge.svelte';

  export let graphic;
  export let isParent = false;
  export let label = undefined;
  export let style = '';
</script>

<span class="graphic" class:is-parent={isParent} {style}>
  {#if isParent}
    <Icon id="list-is-parent" class="material-icons subdirectory_arrow_right"
      >subdirectory_arrow_right</Icon>
  {/if}
  <Text>{label || graphic.meta_title}</Text>
  {#if !graphic.ready}
    <Icon id="list-not-ready" class="material-icons visibility_off">visibility_off</Icon>
  {/if}
  {#if graphic.internal_only}
    <InternalBadge />
  {/if}
</span>

<style lang="scss">
  .graphic {
    font-weight: 900;
    font-size: 14px;
    justify-content: space-between;
    gap: 10px;
    white-space: normal;
    &.is-parent {
      font-weight: 500;
    }
  }

  :global(#list-is-parent) {
    font-size: 1.5em;
    vertical-align: text-bottom;
  }

  :global(#list-not-ready) {
    font-size: 1.5em;
    vertical-align: bottom;
  }

  .graphics-list {
    :global(.sub-list) {
      padding-left: 15px !important;
    }

    :global(.footer.mdc-drawer__header) {
      min-height: 46px;
      padding-bottom: 0px;
    }

    :global(.mdc-deprecated-list-item) {
      height: fit-content !important;
      padding: 8px !important;
      margin-top: 0px !important;
      margin-bottom: 0px !important;
    }

    :global(.mdc-deprecated-list-item__text) {
      white-space: break-spaces;
    }

    :global(.smui-paper__content) {
      padding: 0 !important;
    }

    :global(.smui-accordion__header__title) {
      font-weight: 500;
    }
  }
</style>
